import React, {useState} from 'react';

import {
    Box,
    Button,
    HStack,
} from "@chakra-ui/react";
import { SecureIframe } from './components/SecureIframe';


const Settings: React.FC = () => {
    const baseUrl = process.env.REACT_APP_RESERVE_BASE_URL;
    const [src, setSrc] = useState(`${baseUrl}/shop_manager/shop_table`);

    const menu = [
        { label: "テーブル", url: `${baseUrl}/shop_manager/shop_table` },
        { label: "テーブル接続", url: `${baseUrl}/shop_manager/shop_table_merges` },
        { label: "営業日設定", url: `${baseUrl}/shop_manager/shop_calendar` },
        { label: "休業日設定", url: `${baseUrl}/shop_manager/shop_holiday` },
        { label: "特殊営業日設定", url: `${baseUrl}/shop_manager/shop_day` },
        { label: "その他設定", url: `${baseUrl}/shop_manager/other_settings` },
    ];

    return (
        <Box
            transform="scale(0.8)"
            transformOrigin="top left"
            width="125%"   // 1 / 0.8 = 1.25 → 見切れ防止
            height="125%"
        >
            <HStack spacing={4} mb={4} flexWrap={{ base: 'wrap', md: 'nowrap' }}>
                {menu.map((item) => (
                    <Button
                        key={item.label}
                        onClick={() => setSrc(item.url)}
                        colorScheme="blue"
                        variant="outline"
                    >
                        {item.label}
                    </Button>
                ))}
            </HStack>
            <SecureIframe src={src} />
        </Box>
    );
};

export default Settings;